import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import breakpoints from '../../../design-system/breakpoints';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvRecordDetailsHeaderProps {
  breadcrumbLabel: string;
  backControl: ReactNode;
  current: ReactNode;
  title: ReactNode;
  meta: ReactNode;
  titleAside?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

const OvRecordDetailsHeader: FC<OvRecordDetailsHeaderProps> = ({
  breadcrumbLabel,
  backControl,
  current,
  title,
  meta,
  titleAside = null,
  actions = null,
  children = null,
}) => (
  <Header>
    <Breadcrumb aria-label={breadcrumbLabel}>
      {backControl}
      <span aria-hidden="true">/</span>
      <Current>{current}</Current>
    </Breadcrumb>
    <TitleRow>
      <TitleBlock>
        <TitleLine>
          <h1>{title}</h1>
          {titleAside}
        </TitleLine>
        <Meta>{meta}</Meta>
      </TitleBlock>
      {actions}
    </TitleRow>
    {children}
  </Header>
);

export default OvRecordDetailsHeader;

const Header = styled.header`
  padding: 0.75rem 1.5rem 1.25rem;
  border-bottom: 1px solid ${Colours.OV_BORDER_COLOR_V3};

  @media (max-width: ${breakpoints.md}) {
    padding: 0.75rem 1.25rem 1rem;
  }
`;

const Breadcrumb = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding-bottom: 0.625rem;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};

  button {
    flex: none;
    margin-right: 0;
  }
`;

const Current = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (max-width: ${breakpoints.md}) {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
`;

const TitleBlock = styled.div`
  min-width: 0;
`;

const TitleLine = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem 1.125rem;

  h1 {
    margin: 0;
    font-size: ${Variables.fontSizes.XLARGE};
    overflow-wrap: anywhere;
  }
`;

const Meta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem 0.75rem;
  margin-top: 0.125rem;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
  overflow-wrap: anywhere;
`;
